// extracted by mini-css-extract-plugin
export default {"header":"Limbo_header__HT3Yi","danger":"Limbo_danger__eWJiZ"};